import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useState } from "react";
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import MatrixLineTooltip from "../development/MatrixLineTooltip";

const MatrixMomentLineChart = ({ data, lowerScale, upperScale, totalResponses, graphColor }) => {
  const [hoveredLine, setHoveredLine] = useState(null);

  // Ensure data is not empty before processing
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Extract unique keys for dynamic data
  const uniqueRowTitles = Object.keys(data[0]).filter((key) => key !== "name");

  // Custom legend component
  const CustomizedLegend = ({ payload }) => (
    <ul>
      {payload.map((entry, index) => {
        const rowTitle = entry.dataKey;

        return (
          <li
            key={`item-${index}`}
            onMouseEnter={() => setHoveredLine(rowTitle)}
            onMouseLeave={() => setHoveredLine(null)}
            style={{
              cursor: "pointer",
              fontWeight: hoveredLine === rowTitle ? "bold" : "normal",
              color: entry.color,
            }}
          >
            {rowTitle}
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={data.map((item) =>
            Object.fromEntries(
              Object.entries(item).map(([key, value]) => {
                if (key === "name") {
                  return [key, value];
                } else {
                  return [key, value.value];
                }
              })
            )
          )}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <XAxis dataKey="name" axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <YAxis domain={[0, upperScale]} axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <Tooltip content={(props) => <MatrixLineTooltip {...props} />} />
          <Legend content={<CustomizedLegend />} verticalAlign="bottom" wrapperStyle={{ color: graphColor || undefined }} />
          {uniqueRowTitles.map((rowTitle, index) => (
            <Line
              key={`line-${index}`}
              type="monotone"
              dataKey={rowTitle}
              stroke={data[0][rowTitle]?.color || "#206c7f"}
              strokeWidth={2}
              opacity={hoveredLine && hoveredLine !== rowTitle ? 0.3 : 1}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default MatrixMomentLineChart;
